<template>
  <div class="modal-card card-theme">
    <header class="modal-card-head"> 
        <h4 class="modal-card-title" >
          {{isBulkReceive ? 'Bulk Receive Deliveries': 'Receive Delivery'}}
           <span class="line-height required-label is-size-5 is-italic is-pulled-right mr-0 has-text-weight-normal"
           >
            * required
          </span>
        </h4>
      </header>
      <section class="modal-card-body is-size-2 is-marginless" ref="modalCardBody">
        <div class="columns">
          <div class="column">            
           <h3 class="is-size-3 has-text-weight-semibold is-italic has-text-black-bis mb-5">
            {{isBulkReceive ?'Order:': 'Delivery:'}} <span class="has-text-weight-normal is-size-3 ">{{ rowData.name }}</span>
           </h3>
           <h3 class="is-size-3 has-text-weight-semibold is-italic has-text-black-bis mb-5">
            <span class="mr-2">Destination Project: </span> <span class="has-text-weight-normal is-size-3 ">{{ $_.get(rowData, 'delivery.deliveryProject.name', '') }}</span>
           </h3>
            <h3 class="is-size-3 has-text-weight-semibold is-italic has-text-black-bis">
            <span class="mr-2">Delivery Location: </span> <span class="has-text-weight-normal is-size-3 ">{{ $_.get(rowData, 'delivery.deliveryLocation.name', '') }}</span>
           </h3>
          </div>
        </div>
        <div class="columns">
              <div class="column is-align-items-center is-flex">
                <span class="is-size-3 has-text-weight-semibold is-italic has-text-black-bis is-pulled-left mr-2">
                  {{isBulkReceive ?'Earliest:': ''}} Ship By:</span>
                 <span class="is-pulled-left"> 
                  <field-date 
                      :item="rowData"
                       :inputProps="{ kind: '_delivery.deliveryStart', disableEdit: true }"
                      :is-edit="false"
                      ></field-date>
                  </span>
              </div>
              <div class="column  is-align-items-center is-flex">
                <span class="is-size-3 has-text-weight-semibold is-italic has-text-black-bis is-pulled-left mr-2">{{isBulkReceive ? 'Latest Deliver By': 'Deliver By'}}:</span>
                 <span class="is-pulled-left">
                   <field-date 
                      :item="rowData"
                      :input-props="{
                        kind: 'delivery.deliverBy', 
                       }"
                      :is-edit="true"></field-date>
                 </span>
              
              </div>
            </div>
        <div class="is-divider my-0"></div>
        <div class="field mt-2">
            <div class="columns">
                <div class="column">
                    <h4 class="is-size-3 is-italic has-text-weight-semibold">Receipt Type <span class="has-text-weight-normal has-text-gray-lighter">(All non-Install Items)</span></h4>
                    <div class="field-body">
                        <div v-for="opt in receiptOpts" :key="opt.key"
                                class="mb-2 has-text-black-bis line-height">
                            <input type="radio"
                                    :id="opt.key"
                                    :value="opt.key"
                                    v-model="receiptType"
                            />
                            <label :for="opt.key" class="has-text-black-bis">{{ opt.title }}</label>
                        </div>
                    </div>
                </div>
             </div>
        </div>
        <div class="columns">
            <div class="column">
              <h3 class="is-size-3 has-text-weight-semibold is-italic has-text-black-bis mb-5">Delivery Note</h3>
              <textarea class="textarea" v-model="rowData._delivery.notes"></textarea>
            </div>
            <div class="column">
              <order-notify :value="rowData.delivery.notify"
              :order="rowData"
              :isDelivery="true"
              :projectUsers="projectUsers[rowData.delivery?.deliveryProject._id]"
              @addNotifier="updateNotifiers"
              >
            </order-notify>
            </div>
        </div>
        <div class="table-container" v-if="isBulkReceive">
          <h3 class="is-size-3 has-text-weight-semibold is-italic has-text-black-bis mb-2">Select Deliveries*</h3>
            <mf-table
                ref="shipTable"
                :apiMode="false"
                :checkedRows="checkedRow"
                :tableProps="tableCols.receiveDeliveries"
                :loadData="loadData"
                tableName="ShippingReceive"
                @checkbox-toggled="selectedRow"
                class="mt-0"
            >
            <template v-slot:shippingStatus="{ rowData: delivery }">
              <field-stage
                :isEditing="true"
                :shipType="delivery.shipType"
                :value="delivery.status"
                :shippingItems="delivery.items"
                :isStatus="true"
              ></field-stage>
            </template>
            </mf-table>
        </div>
        <div class="table-container" v-else>
            <mf-table
                ref="shipTable"
                :apiMode="true"
                :checkedRows="checkedRow"
                :tableProps="tableProps"
                :loadData="loadData"
                tableName="ShippingReceive"
                @checkbox-toggled="itemSelected"
                :key="updateTable"
            >
                <template v-slot:availableQty="{ rowData: item }">
                    <qty-input
                        v-model.number="item.selectedQty"
                        :value="item.selectedQty"
                        :max="item.available"
                        @input="itemQtyChanged(item)"
                        :roundTo="4"
                    >
                    </qty-input>
                    <span class="icon" v-show="item.showPopup">
                                    <i class="fa-question-circle fa f-13">
                                    </i>
                    </span>
                </template>
                <template v-slot:selectError="{ rowData: item, rowIndex }">
                    <mf-multi-select
                        :modelValue="item.issueNote"
                        :options="errorOptions"
                        :closeOnSelect="true"
                        label="title"
                        track-by="key"
                        :openDirection="rowIndex === 0 ? 'bottom' : 'top'"
                        :multiple="false"
                        :searchable="false"
                        :showOnDisabled="true"
                        @open="scrollModalToBottom"
                        :disabled="(item.selectedQty === item.available)"
                        @update:modelValue="item.issueNote = $event"
                    />
                </template>
            </mf-table>
        </div>
      </section>     
      <footer class="">
        <div class="is-size-5 footer-note has-text-weight-normal" v-if="isBulkReceive">
          <p>
            NOTE: Deliveries containing “Short” items (Missing, Damaged, Not To Spec) must be received individually to capture actual received quantity and issue type.
          </p>
          </div>
        <div class="modal-card-foot is-justify-content-flex-end">
          <button class="button is-outlined" @click="cancel()">Cancel</button>
          <button v-if="isBulkReceive"
            class="button has-background-black-bis"
            @click="receiveDeliveries(receiptType)"
            :disabled="!selectedDeliveries.length"
          >Receive Deliveries</button>
          <button v-else
            class="button has-background-black-bis"
            @click="receiveShipment(receiptType)"
            :disabled="isReceiveDisabled"
          >Receive Delivery</button>
        </div>
      </footer>
  </div>
  <o-loading :active="isLoading" :full-page="false" :can-cancel="true"/>
</template>

<script>
import {
   reactive, toRefs, ref, defineAsyncComponent, onMounted, computed, nextTick
} from 'vue';
import tableDefinition from '@/components/table-cols/shippingRecieveConfig';
import _ from 'lodash';
import { useToast } from 'vue-toastification';
import { useStore } from 'vuex';
import Shipping from '@/models/Shipping';
import QtyInput from '@/components/fields/QtyInput.vue';
import { useRouter, useRoute } from 'vue-router';
import BaseCardColumn from '@/components/card-edit/BaseCardColumn.vue';
import SearchBar from '@/components/SearchBar.vue';
import { v4 as uuid } from 'uuid';
import Projects from '@/models/Projects';
import MfDate from '@/components/abstract/MfDate.vue';
import OrderNotify from '@/components/OrderNotify.vue';

const MfTable = defineAsyncComponent(() => import('@/components/table-fields/MfTable.vue'));

export default {
  name: 'ReceiveDelivery',
  props: {
    rowData: {
      type: Object,
      default: () => {
      },
    },
    isBulkReceive: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    MfTable,
    'qty-input': QtyInput,
    'base-column': BaseCardColumn,
    'search-bar': SearchBar,
    MfDate,
    'order-notify': OrderNotify,
  },
  setup(props, { emit }) {
    const toast = useToast();
    const store = useStore();
    const router = useRouter();
    const shipTable = ref(null);
    const data = reactive({
      tableProps: tableDefinition.tableBasics,
      cardConfig: tableDefinition.modalBasics,
      tableCols: tableDefinition,
      errorOptions: [
        {
          title: 'Damage',
          key: 'damage',
        }, {
          title: 'Missing',
          key: 'missing',
        }, {
          title: 'Not to spec',
          key: 'notToSpec',
        },
      ],
      receiptOpts: [
        {
          title: 'To Storage',
          key: 'receive',
          receiptType: 'receive',
        },
        {
          title: 'To Inventory',
          key: 'release',
          receiptType: 'release',
        },
        {
          title: 'Mark Complete ("Installed")',
          key: 'fulfilled',
          receiptType: 'fulfilled',
        },
      ],
      receiptType: 'receive',
      isLoading: false,
      shipment: props.rowData,
      updateTable: 0,
      selectedDeliveries: [],
      projectUsers: {},
    });
    const projectId = props.rowData.delivery.currentProject._id;
    const cancel = () => {
      emit('close');
      emit('refresh-card');
    };

    const loadData = (() => {
      if (props.isBulkReceive) {
       if( props.rowData.shipType === 's-m'){
         return props.rowData.status === 'in-transit' ? [props.rowData] : [];
       } else {
          return props.rowData.partialShipments.filter((item) => item.status === 'in-transit' );
       }
      } else {
        const items = data.shipment.items.filter((item) => {
        if (item.qtyToShip === 0) {
          return false;
        }
        item.available = item.quantity;
        _.set(item, 'selectedQty', item.available);
        if (data.searchedValue) {
          return item.name.toLowerCase()
            .includes(data.searchedValue.toLowerCase());
        }
        _.set(item, 'uid', uuid());
        return item;
      });
        const ItemList = {
          data: items,
          total: items.length,
        };
        return ItemList;
      }
    });

    const itemQtyChanged = (item) => {
      if (item.selectedQty > (item.quantity || item.available)) {
        item.selectedQty = item.available;
      }
      if (item.selectedQty < 0) {
        item.selectedQty = 0;
      }
      if (item.selectedQty >= item.available) {
        item.issueNote = null;
      }
    };
    const getSearchValue = ((searchText) => {
      data.searchedValue = searchText;
      loadData();
      data.updateTable++;
    });

     const releaseToInv = async (shipment) => {
      try {
        data.isLoading = true;
        const newPs = await shipment.relaunchAndRelease(shipment.delivery.currentLocation);
        toast.success(`Items Released To Inventory at Location ${shipment.delivery.currentLocation.name}`);
        return newPs;
      } catch (e) {
        console.log('Error', e);
      } finally {
        data.isLoading = false;
      }
    };

    const takeActions = async (shipment, postSaveAction) => {
      let newPS = {};
      if (postSaveAction === 'release') {
        newPS = await releaseToInv(shipment)
      }else if (postSaveAction === 'receive') {
        newPS = await shipment.receive();
        let currentProject = store.getters
          .findProject({ _id: newPS.delivery.currentProject._id });
        let deliveryProject = store.getters
          .findProject({ _id: newPS.delivery.deliveryProject._id });
        if (_.isEmpty(currentProject) && newPS.delivery.currentProject._id
          === store.state.queryParams.commonStockProject._id) {
          currentProject = store.state.queryParams.commonStockProject;
        }
        if (_.isEmpty(deliveryProject) && newPS.delivery.deliveryProject._id
          === store.state.queryParams.commonStockProject._id) {
          deliveryProject = store.state.queryParams.commonStockProject;
        }
        if (!currentProject?.isGI && deliveryProject?.isGI) {
          await Shipping.releaseToInventory({ shippingLabelId: newPS.relayedToShipment });
        }
      } else if (postSaveAction === 'fulfilled') {
        newPS = await shipment.markFulfilled();
        const currentProject = store.getters
          .findProject({ _id: newPS.delivery.currentProject._id });
        const deliveryProject = store.getters
          .findProject({ _id: newPS.delivery.deliveryProject._id });
        if (currentProject.isGI && !deliveryProject.isGI) {
          await Shipping.receiveAll({
            shippingLabelId: newPS.relayedToShipment,
            isFinal: true,
          });
        }
      }
      return newPS;
    }

		const receiveDeliveries = async (postSaveAction) => {
      data.isLoading = true;
      for await (const delivery of data.selectedDeliveries) {
        if (delivery) {
          await takeActions(delivery, postSaveAction, true);
        }
      }
      toast.success('Deliveries received successfully');
      cancel();
		}

    const receiveShipment = async (postSaveAction) => {
      data.isLoading = true;
      const validate = data.shipment.validateLabel();
      if (validate.error) {
        toast.error(validate.errText);
        return;
      }

 
      try {
        for (const item of data.shipment.items) {
          if (item.selectedQty < item.quantity) {
            item.isUnderDeliver = true;
            item.underDeliver = item.quantity - item.selectedQty;
            item.quantity = item.selectedQty;
            data.shipment.isUnderDeliver = true;
          }
        }
        const newPS = await takeActions(data.shipment, postSaveAction)
        toast.success('Shipment received successfully');
        if (newPS && newPS.parentShipment && store.state.activeScreen !== 'shipping-order-view') {
          router.replace({
            name: 'shipping-card-edit',
            params: {
              cardId: newPS.parentShipment,
              projectId: newPS.project._id,
            },
          });
        } 
      } catch (e) {
        toast.error(e.message || e.data.message || 'Error while processing shipment. Please try again later', '');
        console.log('Error while processing shipment', e);
      } finally{
        cancel();
        data.isLoading = false;
      }
    };

    const selectedRow = (rows) => {
      data.selectedDeliveries = rows;
    }
    const updateNotifiers = (notifyUsers) => {
      set(props.rowData, 'delivery.notify', notifyUsers);
    };
    const fetchUsers = async (pId) => {
      const allUsers = await Projects.linkedProjectUsers([pId]);
      const users = _.filter(allUsers, (usr) => usr.company === _.get(store.state.userData, 'company._id', store.state.userData.company));
    return users;
    };
    onMounted (async ()=> {     
      data.projectUsers[projectId] = [];
      if (_.isEmpty(data.projectUsers[projectId])) {      
        const users = await fetchUsers(projectId);        
        if (users.length) data.projectUsers[projectId] = users;
      }
    })

    const isReceiveDisabled = computed(() => {
      if (!data.shipment?.items?.length) return true;

      return data.shipment.items.some(item => {
        const isShort = item.selectedQty < item.available;
        const noIssueSelected = !item.issueNote;
        return isShort && noIssueSelected;
      });
    });
    const modalCardBody = ref(null);
    function scrollModalToBottom() {
      nextTick(); // wait until dropdown DOM is rendered
      const el = modalCardBody.value;
       // el.scrollToTop = el.scrollHeight; // jump to bottom
      el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
    };
    return {
      ...toRefs(data),
      cancel,
      loadData,
      itemQtyChanged,
      receiveShipment,
      getSearchValue,
      selectedRow,
      receiveDeliveries,
      updateNotifiers,
      isReceiveDisabled,
      scrollModalToBottom,
      modalCardBody,
    };
  },

};
</script>

<style scoped>
::v-deep(.o-table tbody) {
    min-height: 200px !important;
    max-height: 200px !important;
}
 .modal-card-head {
    background-color: #fff !important;
    border-bottom: none !important;
  }
  .modal-card-foot {
    border-top: 1px solid #84888c;
     background-color: #fff !important;
  }
  .textarea {
    height: 160px;
    margin-top: 25px;
  }
</style>
